module.exports = __webpack_public_path__ + "static/media/urbanTransport_interIntra_white_logo.8b00bc75.svg";